import * as React from 'react';
import CategoryNavigation from './components/category-navigation';
import ProductListFilters from './components/product-list-filters';
import ProductList from './components/product-list';
import ProductListPagination from './components/product-list-filters/product-list-pagination';
import ProductListHeadMetadata from './components/product-list-head-metadata';
import ProductListPageSummary from './components/product-list-page-summary';
import SeoSection from './components/seo-section';
import { ICusProductListViewProps } from './cus-product-list.data';
import useProductList from './hooks/useProductList';
import { buildPlpMetadata } from './hooks/buildPlpMetadata';
import HeadRedirection from './components/head-redirection';

export default (props: ICusProductListViewProps) => {
    const {
        plpRef,
        pageTitle,
        totalItems,
        productCountText,
        isEmptySearch,
        isLoading,
        isSearchPage,
        itemsPerPage,
        categoryRecordId,
        currentSort,
        handleSortChange,
        mobileColumns,
        setMobileColumns,
        search,
        hasNoResults,
        activeProducts,
        totalPages,
        currentPage,
        handlePageChange
    } = useProductList(props);

    const currentCategory = props.data.currentCategoryData.result?.currentCategory ?? null;
    const parentCategory = props.data.currentCategoryData.result?.parentCategory ?? null;
    const { pageSummary, headMetadata } = buildPlpMetadata({
        context: props.context,
        activeProducts,
        currentCategory,
        parentCategory,
        currentPage,
        isCategoryPage: !isSearchPage,
        pageTitle,
        homeLabel: props.resources.homeBreadcrumbLabel
    });

    return (
        <div className='bs-product-list' ref={plpRef} data-testid='plp-root'>
            <h1 className='bs-product-list__title' data-testid='plp-title'>
                {pageTitle}
                {totalItems > 0 && <span className='bs-product-list__product-count'>{productCountText}</span>}
            </h1>
            <div className='bs-product-list__body'>
                {!isSearchPage && categoryRecordId && (
                    <section>
                        <CategoryNavigation
                            response={props.data.currentCategoryData}
                            subCategoriesAriaLabel={props.resources.subCategoriesAriaLabel}
                        />
                    </section>
                )}
                {isEmptySearch && <p className='bs-product-list__empty-search'>{props.resources.emptySearchQueryText}</p>}
                {!isEmptySearch && (
                    <ProductListFilters
                        props={props}
                        currentSort={currentSort}
                        onSortChange={handleSortChange}
                        mobileColumns={mobileColumns}
                        onMobileColumnsChange={setMobileColumns}
                        onSearch={search}
                        isLoading={isLoading}
                    />
                )}
                {hasNoResults && <p className='bs-product-list__empty-search'>{props.resources.resultSearchNotFoundText}</p>}
                <ProductList props={props} categoryProducts={activeProducts} mobileColumns={mobileColumns} />
                {totalPages > 1 && (
                    <ProductListPagination
                        props={props}
                        currentPage={currentPage}
                        totalPages={totalPages}
                        totalItems={totalItems}
                        itemsPerPage={itemsPerPage}
                        onPageChange={handlePageChange}
                    />
                )}
            </div>
            <SeoSection props={props} />
            <ProductListPageSummary {...pageSummary} />
            <ProductListHeadMetadata {...headMetadata} />
            {pageSummary.redirectUrl && <HeadRedirection redirectUrl={pageSummary.redirectUrl} />}
        </div>
    );
};
